const prefixCls = '';

export const localesShop = {
  // 店铺授权相关
  [prefixCls + 'shop.title']: {
    zh_CN: '店铺授权',
    en_GB: 'Shop Authorization',
  },
  [prefixCls + 'shop.form.label.account']: {
    zh_CN: '账号',
    en_GB: 'Account',
  },
  [prefixCls + 'shop.form.label.password']: {
    zh_CN: '密码',
    en_GB: 'Password',
  },
  [prefixCls + 'shop.form.placeholder.password']: {
    zh_CN: '请输入密码',
    en_GB: 'Please enter password',
  },
  [prefixCls + 'shop.form.placeholder.account']: {
    zh_CN: '请输入账号',
    en_GB: 'Please enter account',
  },
  [prefixCls + 'shop.form.validation.accountRequired']: {
    zh_CN: '请输入账号',
    en_GB: 'Please enter account',
  },
  [prefixCls + 'shop.form.validation.passwordRequired']: {
    zh_CN: '请输入密码',
    en_GB: 'Please enter password',
  },
  [prefixCls + 'shop.form.validation.emailFormat']: {
    zh_CN: '请输入有效的邮箱地址',
    en_GB: 'Please enter a valid email address',
  },
  [prefixCls + 'shop.form.validation.passwordMinLength']: {
    zh_CN: '密码至少需要6位字符',
    en_GB: 'Password must be at least 6 characters',
  },
  [prefixCls + 'shop.button.authorize']: {
    zh_CN: '授权',
    en_GB: 'Authorize',
  },
  [prefixCls + 'shop.message.authorizeSuccess']: {
    zh_CN: '授权成功',
    en_GB: 'Authorization successful',
  },
  [prefixCls + 'shop.message.authorizeFailed']: {
    zh_CN: '授权失败',
    en_GB: 'Authorization failed',
  },
  [prefixCls + 'shop.message.userInfoMissing']: {
    zh_CN: '用户信息不存在，请重新登录',
    en_GB: 'User information not found, please login again',
  },
  [prefixCls + 'shop.message.unknownError']: {
    zh_CN: '授权过程中出现未知错误',
    en_GB: 'Unknown error occurred during authorization',
  },
  // 状态相关
  [prefixCls + 'shop.status.authorized']: {
    zh_CN: '已授权',
    en_GB: 'Authorized',
  },
  [prefixCls + 'shop.status.pending']: {
    zh_CN: '授权中',
    en_GB: 'Pending',
  },
  [prefixCls + 'shop.status.unauthorized']: {
    zh_CN: '未授权',
    en_GB: 'Unauthorized',
  },
  // 卡片标题
  [prefixCls + 'shop.card.currentStatus']: {
    zh_CN: '当前授权状态',
    en_GB: 'Current Authorization Status',
  },
  [prefixCls + 'shop.card.authorized']: {
    zh_CN: '店铺已授权',
    en_GB: 'Shop Authorized',
  },
  [prefixCls + 'shop.card.authForm']: {
    zh_CN: '店铺授权',
    en_GB: 'Shop Authorization',
  },
  [prefixCls + 'shop.card.instructions']: {
    zh_CN: '授权说明',
    en_GB: 'Authorization Instructions',
  },
  // 文本标签
  [prefixCls + 'shop.label.accountId']: {
    zh_CN: '账号ID',
    en_GB: 'Account ID',
  },
  [prefixCls + 'shop.label.authorizedAt']: {
    zh_CN: '授权时间',
    en_GB: 'Authorized At',
  },
  [prefixCls + 'shop.label.expiredAt']: {
    zh_CN: '过期时间',
    en_GB: 'Expires At',
  },
  // 按钮
  [prefixCls + 'shop.button.revoke']: {
    zh_CN: '取消授权',
    en_GB: 'Revoke Authorization',
  },
  // 弹窗
  [prefixCls + 'shop.modal.revokeTitle']: {
    zh_CN: '确认取消授权',
    en_GB: 'Confirm Revoke Authorization',
  },
  [prefixCls + 'shop.modal.revokeContent']: {
    zh_CN:
      '确定要取消当前店铺的授权吗？取消后您将无法使用相关功能，需要重新授权。',
    en_GB:
      'Are you sure you want to revoke the current shop authorization? After revocation, you will not be able to use related functions and will need to re-authorize.',
  },
  [prefixCls + 'shop.modal.confirmRevoke']: {
    zh_CN: '确认取消',
    en_GB: 'Confirm Revoke',
  },
  [prefixCls + 'shop.modal.cancel']: {
    zh_CN: '取消',
    en_GB: 'Cancel',
  },
  // 说明文本
  [prefixCls + 'shop.instruction.step1']: {
    zh_CN: '请输入您的noon商家账号和密码进行授权',
    en_GB:
      'Please enter your noon merchant account and password for authorization',
  },
  [prefixCls + 'shop.instruction.step2']: {
    zh_CN: '点击授权按钮后，系统将打开noon授权页面',
    en_GB:
      'After clicking the authorization button, the system will open the noon authorization page',
  },
  [prefixCls + 'shop.instruction.step3']: {
    zh_CN: '在授权页面完成登录和授权确认',
    en_GB:
      'Complete login and authorization confirmation on the authorization page',
  },
  [prefixCls + 'shop.instruction.step4']: {
    zh_CN: '授权成功后，您可以使用相关功能',
    en_GB: 'After successful authorization, you can use related functions',
  },
  [prefixCls + 'shop.instruction.step5']: {
    zh_CN: '请确保账户邮箱和密码正确',
    en_GB: 'Please ensure your account email and password are correct',
  },
  [prefixCls + 'shop.instruction.step6']: {
    zh_CN: '授权成功后如果还有问题可尝试重新登录',
    en_GB:
      'If there are any issues after successful authorization, you can try logging in again',
  },
};
